import React, { Component } from 'react';
import { Callout, Card, EmptyState, Flex } from 'core/components';
import { Table } from 'core/components/table';
import Collection from 'core/model/Collection';
import { timezone, dateTimeFormatter } from 'core/util/dateUtils';

export default class AgentDowntimeTable extends Component {
  static defaultProps = {
    activeTimeslot: null,
    resultTimeMs: null
  };

  getSortValue = (field, model) => {
    const value = model.get(field);

    if (field === 'timestamp' && model.get('state') === 'ALARM_STATE_ACTIVE') {
      return 'N/A';
    }

    if (field === 'duration') {
      return this.durationRenderer(model);
    }

    return value;
  };

  durationRenderer(model) {
    const start = dateTimeFormatter({ value: model.get('start_time') });
    const end =
      model.get('state') === 'ALARM_STATE_ACTIVE' ? 'now' : dateTimeFormatter({ value: model.get('end_time') });

    return `${start} to ${end}`;
  }

  get columns() {
    return [
      {
        label: 'Error',
        name: 'error',
        renderer: () => 'Agent offline'
      },
      {
        label: 'Timestamp',
        name: 'timestamp',
        wrapText: true,
        renderer: ({ model }) => this.durationRenderer(model)
      }
    ];
  }

  /*
    Returns the alarms from the active timeslot
    When there is no active timeslot, an empty array is returned
    and the table's empty state is used
  */
  get alarms() {
    const { activeTimeslot } = this.props;
    return activeTimeslot?.alarms || [];
  }

  get emptyState() {
    const { resultTimeMs } = this.props;

    return (
      <Flex justifyContent="center">
        <Callout width={400} intent="success">
          <EmptyState
            icon="thumbs-up"
            title={`No Incidents for ${dateTimeFormatter({ value: resultTimeMs })} ${timezone.value}`}
            description="There were no issues during this time segment."
          />
        </Callout>
      </Flex>
    );
  }

  render() {
    if (this.alarms.length === 0) {
      return this.emptyState;
    }

    return (
      <Card display="flex" overflow="auto" m="2px">
        <Table
          collection={
            new Collection(this.alarms, {
              sortState: { field: 'timestamp', direction: 'asc' },
              getSortValue: this.getSortValue
            })
          }
          columns={this.columns}
          rowHeight={36}
          selectOnRowClick={false}
          flexed
        />
      </Card>
    );
  }
}
